import { defineComponent, onMounted, ref } from "vue";
import { gsap, ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

export default defineComponent({
  props: {
    columnCount: { type: Number, default: 12 },
    color: { type: String, default: "#ffce32" },
  },
  setup(props) {
    const backgroundContainer = ref<HTMLElement | null>(null);

    const style = (
      n: number
    ): { left: string; width: string; backgroundColor: string } => {
      return {
        left: `${(n - 1) * (100 / props.columnCount)}%`,
        width: `${100 / props.columnCount}%`,
        backgroundColor: props.color,
      };
    };

    onMounted(() => {
      gsap.from(
        backgroundContainer.value!.querySelectorAll(
          ".background_color__column"
        ),
        {
          scaleY: 0,
          transformOrigin: "bottom",
          duration: 2,

          ease: "power4.inOut",
          stagger: {
            amount: 0.4,
            from: "random",
          },
          scrollTrigger: {
            trigger: backgroundContainer.value,
            start: "top 0%",
            // markers: true,
            toggleActions: "play reverse play reverse",
          },
        }
      );
    });

    return { backgroundContainer, style };
  },
});
